import { render } from "./PeriodDetail.vue?vue&type=template&id=796e8d44"
import script from "./PeriodDetail.vue?vue&type=script&lang=js"
export * from "./PeriodDetail.vue?vue&type=script&lang=js"

import "./PeriodDetail.vue?vue&type=style&index=0&id=796e8d44&lang=css"
script.render = render

export default script